import { Component, OnDestroy, OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
import { DialogComponent, DialogService } from 'ngx-bootstrap-modal';
import { DialogYesNoModel } from '..';
declare var $: any; 
@Component({
  selector: 'app-dialog-yes-no-cancel',
  templateUrl: './dialog-yes-no-cancel.component.html'
})

export class DialogYesNoCancelComponent extends DialogComponent<DialogYesNoModel, boolean> implements DialogYesNoModel, OnDestroy, OnInit {
  @ViewChild('buttonYes') buttonYes: ElementRef;
  @ViewChild('buttonNo') buttonNo: ElementRef;
  @ViewChild('buttonCancel') buttonCancel: ElementRef;
  title: string;
  message: any;
  elementId: any;

  constructor(dialogService: DialogService) {
    super(dialogService);
    setTimeout(() => {
      document.getElementById('buttonYes').focus();
    }, 10);
  }

  /**
   * 初期表示
   * */
  ngOnInit() {
    // 背面の固定
    $('body').css('overflow-y', 'hidden'); // 強化テストNo245
  }

  btnYes() {
    this.close(true);
    setTimeout(() => {
      document.getElementById(this.elementId).focus();
    }, 200);
  }

  btnNo() {
    this.close(false);
    setTimeout(() => {
      document.getElementById(this.elementId).focus();
    }, 200);
  }

  btnCancel() {
    this.close(false);
    setTimeout(() => {
      document.getElementById(this.elementId).focus();
    }, 200);
  }

  ngOnDestroy() {
    // 背面の固定解除
    $('body').css('overflow-y', 'scroll'); // 強化テストNo245

    this.close(false);
    setTimeout(() => {
      document.getElementById(this.elementId).focus();
    }, 200);
  }

  @HostListener('window:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    // Tabキーの場合
    if (event.keyCode == 9) {
      if (document.activeElement.id == 'buttonYes') {
        this.buttonNo.nativeElement.focus();
      } else if (document.activeElement.id == 'buttonNo') {
        this.buttonCancel.nativeElement.focus();
      } else {
        this.buttonYes.nativeElement.focus();
      }
      return false;
    }
    // 十字キーの場合
    if (event.keyCode == 37 || event.keyCode == 38 || event.keyCode == 39 || event.keyCode == 40) {
      if (document.activeElement.id == 'buttonYes') {
        this.buttonNo.nativeElement.focus();
      } else if (document.activeElement.id == 'buttonNo') {
        this.buttonCancel.nativeElement.focus();
      } else {
        this.buttonYes.nativeElement.focus();
      }
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/dialog-yes-no-cancel/dialog-yes-no-cancel.component.ts